export default __webpack_public_path__ + "static/media/indimg6.35af3107.webp";